// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.team_main {
  display: flex;
  justify-content: center;
  margin-top: 50px;
}
.team {
  width: 90%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.team_custom-card {
  margin: 0px !important;
}
.member_link_image {
  display: flex;
}

.team_heading {
  font-size: 58px;
  font-weight: 700;
  font-family: "Poppins", sans-serif !important;
  background: linear-gradient(45deg, #5D2B85, #774D98);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.why_choose_heading {
  font-size: 30px; /* Reverting to the original size */
  font-weight: 700;
  font-family: "Poppins", sans-serif !important;
  background: linear-gradient(45deg, #5D2B85, #774D98);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.team_para {
  color: #848484;
  font-size: 24px;
  font-family: "Poppins", sans-serif !important;
  font-weight: 400;
}
.team_card_title {
  font-family: "Poppins", sans-serif !important;
  display: inline-block;
  vertical-align: middle;
  background: linear-gradient(45deg, #5D2B85, #774D98);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.team_div {
  display: flex;
  align-items: center;
  justify-content: center;
}
.team_btn {
  margin-right: 20px;
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 15px 40px;
  font-weight: semibold;
  border-radius: 8px;
  border: none;
  font-family: Sora;
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0.15px;
  background: #f3eafd;
  color: #7e34bc;
}

@media (max-width: 768px) {
  .team_card_title {
    font-family: Sora;
    font-size: 20px;
    font-weight: 600;
    line-height: 28px;
    letter-spacing: 0.15000000596046448px;
    text-align: left;
  }
  .team_card_text {
    font-family: Inter;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    text-align: left;
  }
  .team {
    margin-right: 20px;
  }
  .team_custom-card {
    margin: 10px 0px !important;
  }
  .team_main {
    margin-left: 15px;
  }

  .team_btn {
    /* margin-right: 10px; */
    margin-top: 0px;
    margin-bottom: 0px;
  }
  
  .team_custom-card img {
    filter: none !important; /* Remove grayscale on mobile */
  }
}

/* Media query for mobile devices */
@media (max-width: 480px) {
  .team_btn {
    margin-top: 0px;
    margin-bottom: 0px;
  }

  .team_custom-card img {
    filter: none !important; /* Remove grayscale on mobile */
  }
}

.team_custom-card {
  margin: 10px;
  width: 18rem;
  padding: 10px 10px;
}

.team_card_title {
  font-size: 24px;
  font-weight: 600;
  font-family: "Poppins", sans-serif !important;
}

.team_card_text {
  font-size: 16px;
  font-weight: 400;
  color: #787878;
  font-family: "Poppins", sans-serif !important;
}

.icon {
  color: #000000; /* Default icon color */
  margin-left: 10px;
  font-size: 24px; /* Icon size */
  transition: color 0.3s; /* Smooth color transition */
}

.icon:hover {
  color: #5F2C87; /* Hover color */
}

.card_title_with_icons {
  display: flex;
  align-items: baseline;
  margin-bottom: 10px; /* Adjust this to move icons up or down */
}

.social_icons {
  display: flex;
  align-items: center;
  margin-left: 10px; /* Adjust this to move icons closer to the title */
}

.card_title_with_icons .team_card_title {
  margin-right: auto;
}

/* Black and white effect on image for desktop and larger screens */
@media (min-width: 769px) {
  .team_custom-card img {
    filter: grayscale(100%);
    transition: filter 0.5s ease;
  }

  .team_custom-card:hover img {
    filter: grayscale(0%);
  }
}
`, "",{"version":3,"sources":["webpack://./src/Team/team.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,6CAA6C;EAC7C,oDAAoD;EACpD,6BAA6B;EAC7B,oCAAoC;AACtC;AACA;EACE,eAAe,EAAE,mCAAmC;EACpD,gBAAgB;EAChB,6CAA6C;EAC7C,oDAAoD;EACpD,6BAA6B;EAC7B,oCAAoC;AACtC;AACA;EACE,cAAc;EACd,eAAe;EACf,6CAA6C;EAC7C,gBAAgB;AAClB;AACA;EACE,6CAA6C;EAC7C,qBAAqB;EACrB,sBAAsB;EACtB,oDAAoD;EACpD,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE;IACE,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,qCAAqC;IACrC,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;IACxB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,uBAAuB,EAAE,+BAA+B;EAC1D;AACF;;AAEA,mCAAmC;AACnC;EACE;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,uBAAuB,EAAE,+BAA+B;EAC1D;AACF;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,cAAc,EAAE,uBAAuB;EACvC,iBAAiB;EACjB,eAAe,EAAE,cAAc;EAC/B,sBAAsB,EAAE,4BAA4B;AACtD;;AAEA;EACE,cAAc,EAAE,gBAAgB;AAClC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB,EAAE,yCAAyC;AAChE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB,EAAE,kDAAkD;AACvE;;AAEA;EACE,kBAAkB;AACpB;;AAEA,mEAAmE;AACnE;EACE;IACE,uBAAuB;IACvB,4BAA4B;EAC9B;;EAEA;IACE,qBAAqB;EACvB;AACF","sourcesContent":[".team_main {\n  display: flex;\n  justify-content: center;\n  margin-top: 50px;\n}\n.team {\n  width: 90%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n.team_custom-card {\n  margin: 0px !important;\n}\n.member_link_image {\n  display: flex;\n}\n\n.team_heading {\n  font-size: 58px;\n  font-weight: 700;\n  font-family: \"Poppins\", sans-serif !important;\n  background: linear-gradient(45deg, #5D2B85, #774D98);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n.why_choose_heading {\n  font-size: 30px; /* Reverting to the original size */\n  font-weight: 700;\n  font-family: \"Poppins\", sans-serif !important;\n  background: linear-gradient(45deg, #5D2B85, #774D98);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n.team_para {\n  color: #848484;\n  font-size: 24px;\n  font-family: \"Poppins\", sans-serif !important;\n  font-weight: 400;\n}\n.team_card_title {\n  font-family: \"Poppins\", sans-serif !important;\n  display: inline-block;\n  vertical-align: middle;\n  background: linear-gradient(45deg, #5D2B85, #774D98);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.team_div {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.team_btn {\n  margin-right: 20px;\n  margin-top: 20px;\n  margin-bottom: 20px;\n  padding: 15px 40px;\n  font-weight: semibold;\n  border-radius: 8px;\n  border: none;\n  font-family: Sora;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 20px;\n  letter-spacing: 0.15px;\n  background: #f3eafd;\n  color: #7e34bc;\n}\n\n@media (max-width: 768px) {\n  .team_card_title {\n    font-family: Sora;\n    font-size: 20px;\n    font-weight: 600;\n    line-height: 28px;\n    letter-spacing: 0.15000000596046448px;\n    text-align: left;\n  }\n  .team_card_text {\n    font-family: Inter;\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 16px;\n    text-align: left;\n  }\n  .team {\n    margin-right: 20px;\n  }\n  .team_custom-card {\n    margin: 10px 0px !important;\n  }\n  .team_main {\n    margin-left: 15px;\n  }\n\n  .team_btn {\n    /* margin-right: 10px; */\n    margin-top: 0px;\n    margin-bottom: 0px;\n  }\n  \n  .team_custom-card img {\n    filter: none !important; /* Remove grayscale on mobile */\n  }\n}\n\n/* Media query for mobile devices */\n@media (max-width: 480px) {\n  .team_btn {\n    margin-top: 0px;\n    margin-bottom: 0px;\n  }\n\n  .team_custom-card img {\n    filter: none !important; /* Remove grayscale on mobile */\n  }\n}\n\n.team_custom-card {\n  margin: 10px;\n  width: 18rem;\n  padding: 10px 10px;\n}\n\n.team_card_title {\n  font-size: 24px;\n  font-weight: 600;\n  font-family: \"Poppins\", sans-serif !important;\n}\n\n.team_card_text {\n  font-size: 16px;\n  font-weight: 400;\n  color: #787878;\n  font-family: \"Poppins\", sans-serif !important;\n}\n\n.icon {\n  color: #000000; /* Default icon color */\n  margin-left: 10px;\n  font-size: 24px; /* Icon size */\n  transition: color 0.3s; /* Smooth color transition */\n}\n\n.icon:hover {\n  color: #5F2C87; /* Hover color */\n}\n\n.card_title_with_icons {\n  display: flex;\n  align-items: baseline;\n  margin-bottom: 10px; /* Adjust this to move icons up or down */\n}\n\n.social_icons {\n  display: flex;\n  align-items: center;\n  margin-left: 10px; /* Adjust this to move icons closer to the title */\n}\n\n.card_title_with_icons .team_card_title {\n  margin-right: auto;\n}\n\n/* Black and white effect on image for desktop and larger screens */\n@media (min-width: 769px) {\n  .team_custom-card img {\n    filter: grayscale(100%);\n    transition: filter 0.5s ease;\n  }\n\n  .team_custom-card:hover img {\n    filter: grayscale(0%);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
